var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "white",
    strokeOpacity: 0.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4917 11.6667H16.5084C13.475 11.6667 11.6667 13.4751 11.6667 16.5084V23.4834C11.6667 26.5251 13.475 28.3334 16.5084 28.3334H23.4834C26.5167 28.3334 28.325 26.5251 28.325 23.4917V16.5084C28.3334 13.4751 26.525 11.6667 23.4917 11.6667ZM20 23.2334C18.2167 23.2334 16.7667 21.7834 16.7667 20.0001C16.7667 18.2167 18.2167 16.7667 20 16.7667C21.7834 16.7667 23.2334 18.2167 23.2334 20.0001C23.2334 21.7834 21.7834 23.2334 20 23.2334ZM24.9334 15.7334C24.8917 15.8334 24.8334 15.9251 24.7584 16.0084C24.675 16.0834 24.5834 16.1417 24.4834 16.1834C24.3834 16.2251 24.275 16.2501 24.1667 16.2501C23.9417 16.2501 23.7334 16.1667 23.575 16.0084C23.5 15.9251 23.4417 15.8334 23.4 15.7334C23.3584 15.6334 23.3334 15.5251 23.3334 15.4167C23.3334 15.3084 23.3584 15.2001 23.4 15.1001C23.4417 14.9917 23.5 14.9084 23.575 14.8251C23.7667 14.6334 24.0584 14.5417 24.325 14.6001C24.3834 14.6084 24.4334 14.6251 24.4834 14.6501C24.5334 14.6667 24.5834 14.6917 24.6334 14.7251C24.675 14.7501 24.7167 14.7917 24.7584 14.8251C24.8334 14.9084 24.8917 14.9917 24.9334 15.1001C24.975 15.2001 25 15.3084 25 15.4167C25 15.5251 24.975 15.6334 24.9334 15.7334Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.e5d19c9bcd53af7c570920ca6cfef4f0.svg";
export { ForwardRef as ReactComponent };